import "./FourthScreen.css";
import ringvidmobile from "../videos/ringvid2.mp4";
import BESMARTdiag from "../photos/BESMARTdiag.png";
import { useState, useEffect } from "react";

function useWindowSize() {
  const [size, setSize] = useState({
    w: window.innerWidth,
    h: window.innerHeight,
  });

  useEffect(() => {
    const onResize = () =>
      setSize({ w: window.innerWidth, h: window.innerHeight });
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return size;
}

function FourthScreen() {
  const { w } = useWindowSize();
  return (
    <div className="FourthScreen">
      {w > 768 ? (
        <video
          className="FourthScreenVideo"
          src={ringvidmobile}
          loop
          autoPlay
          muted
          playsInline
          preload="none"
        />
      ) : (
        <video
          className="FourthScreenVideo"
          src={ringvidmobile}
          loop
          autoPlay
          muted
          playsInline
          preload="none"
        />
      )}
      <img
        className="FourthScreenImage"
        loading="lazy"
        src={BESMARTdiag}
        alt="BESMART Diagram"
      />
    </div>
  );
}

export default FourthScreen;
